import React, { useEffect, useState } from 'react';
import Select from 'component/atom/forms/select/select/Select';
import Modal from 'component/hoc/modal/Modal';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { usePost } from 'hooks/usePost';
import { useFetch } from 'hooks/useFetch';
import { knowledgeBase } from 'hooks/endpoints';
import styles from './AddDataSourceForm.module.scss';
import Button from 'component/atom/forms/button/Button';
import Input from 'component/atom/forms/input/input/Input';
import MultipleFileUpload from 'component/atom/forms/upload-file/MultipleFileUpload';
import RadioGroup from 'component/atom/forms/radio-group/RadioGroup';
import { knowledgeBaseToast } from 'helpers/toastMessages';
import { useToast } from 'app-context/toasterContext/ToastContext';
import axios from 'axios';
import { securityHeaders } from 'helpers/headers';
import { useUserContext } from 'app-context/user/UserContext';
import { API_URL } from 'constants';

const Form = ({
  formik,
  options,
  selectedValue,
  setSelectedValue,
  isPending,
  folderId,
}) => {
  const { selectedBot } = useUserContext();

  // const { data: folders, isFetching: isFetchingFolders } = useFetch(
  //   ['getFolders'],
  //   knowledgeBase?.getFolder
  // );
  const { data: folders, isFetching: isFetchingFolders } = useFetch(
    ['getFolders'],
    knowledgeBase?.getFoldersByBotId(selectedBot?.botId)
  );
  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const foldersData = folders?.data?.map((val) => ({
    value: val.folderId,
    label: val.folderName,
  }));
  return (
    <form
      autoComplete='off'
      onSubmit={formik.handleSubmit}
      className={styles['form']}
    >
      <div
        className={`${styles['form-container']} add-data-source-modal`}
        id='add-data-source-modal'
      >
        {!folderId ? (
          <RadioGroup
            name='uploadOrUrl'
            // label="Choose how to add content"
            selectedValue={selectedValue}
            onChange={handleChange}
            options={[
              { value: 'upload', label: 'Upload' },
              { value: 'url', label: 'Add URL' },
            ]}
          />
        ) : null}

        {selectedValue === 'upload' ? (
          <MultipleFileUpload
            setSelectedFiles={(files) => formik.setFieldValue('files', files)}
            value={formik.values.files}
            singleFile
          />
        ) : (
          <Input
            label='URL'
            placeholder='Enter URL'
            options={options}
            name='Url'
            value={formik.values.Url}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors.Url}
            touched={formik.touched.Url}
          />
        )}
        {!folderId && selectedValue === 'upload' ? (
          <Select
            label='Folder Location'
            placeholder='Select Folder Location'
            options={foldersData}
            name='FolderId'
            value={formik.values.FolderId}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors.FolderId}
            touched={formik.touched.FolderId}
            isLoading={isFetchingFolders}
          />
        ) : null}
      </div>

      <Button
        type='save'
        label='Save'
        isLoading={isPending}
        onClick={formik.handleSubmit}
      />
    </form>
  );
};

const AddDataSource = ({
  isOpen,
  onClose,
  selectedItems,
  setRefetch,
  folderId,
}) => {
  const { selectedBot } = useUserContext();
  const toast = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const { mutate: upload, isPending } = usePost({
    onSuccessToast: knowledgeBaseToast.uploadFile,
    toastType: 'add',
  });
  const [selectedValue, setSelectedValue] = useState('upload');
  let validationSchema;
  if (selectedValue === 'upload') {
    validationSchema = Yup.object({
      files: Yup.array().min(1, 'At least one file must be uploaded'),

      // FolderId: Yup.string().required('Folder Location is required'),
    });
  } else {
    validationSchema = Yup.object({
      Url: Yup.string().required('URL is required').url('Invalid URL format'),

      // FolderId: Yup.string().required("Folder Location is required"),
    });
  }
  const formik = useFormik({
    initialValues: {
      FolderId: folderId || '',
      Url: '',
      files: [],
    },
    validationSchema,
    onSubmit: async (values) => {
      setIsLoading(true);
      const formData = new FormData();

      if (values?.files.length > 0 && selectedValue === 'upload') {
        formData.append('file', values.files[0]);
      }

      formData.append('BotId', selectedBot?.botId);
      if (values?.Url && selectedValue === 'url') {
        formData.append('WebsiteUrl', values.Url);
      }
      try {
        formData.append('FolderId', values.FolderId);
        const response = await axios.post(`${API_URL}/Azure/UploadBlobToContainer`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            ...securityHeaders(),
          },
        });

        toast.open(response?.data?.userMessage, 'add');

        onClose();
        setRefetch(true);
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        toast.open('Error uploading file', error);
      }
    },
    enableReinitialize: true,
  });

  return (
    <div>
      {isPending &&
        selectedValue !== 'upload' &&
        toast.open(knowledgeBaseToast.urlWaiting, 'update')}
      <Modal
        title='Upload a file'
        isOpen={isOpen}
        onClose={onClose}
        onSubmit={formik.handleSubmit}
        buttonType='submit'
      >
        <Form
          formik={formik}
          selectedValue={selectedValue}
          setSelectedValue={setSelectedValue}
          isPending={isLoading}
          folderId={folderId}
          // options={refreshRateOptions}
        />
      </Modal>
    </div>
  );
};

export default AddDataSource;
